"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterApi = void 0;
var Filters_1 = require("./IO/Input/Filters");
var Error_1 = require("./IO/Output/Error");
/**
 * Api helps create specific Filter
 */
var FilterApi = /** @class */ (function () {
    function FilterApi() {
    }
    FilterApi.category = function (category) {
        return new Filters_1.CategoryFilter(category);
    };
    FilterApi.product = function (productId) {
        return new Filters_1.ProductFilter(productId);
    };
    FilterApi.minPrice = function (minPrice) {
        return new Filters_1.MinPriceFilter(minPrice);
    };
    FilterApi.maxPrice = function (maxPrice) {
        return new Filters_1.MaxPriceFilter(maxPrice);
    };
    FilterApi.getFilterParams = function (filters) {
        if (!filters) {
            return {};
        }
        var filterParams = {};
        filters.forEach(function (filter) {
            if (!filter.enableMultiple && typeof filterParams[filter.urlParam] !== 'undefined') {
                throw new Error_1.RecommendationError('Filter used multiple times');
            }
            filterParams[filter.urlParam] = FilterApi.appendFilterParams(filter.value, filterParams[filter.urlParam]);
        });
        return filterParams;
    };
    FilterApi.appendFilterParams = function (filterValue, urlParam) {
        if (typeof urlParam === 'undefined') {
            return filterValue.toString().trim();
        }
        return urlParam + ',' + filterValue.toString().trim();
    };
    return FilterApi;
}());
exports.FilterApi = FilterApi;
//# sourceMappingURL=FilterApi.js.map